import { useEffect } from 'react';

const APP_NAME = 'EasyAI';

// Pages set a specific title; Layout supplies the nav label as a fallback.
let pageTitle: string | null = null;
let fallbackTitle: string | null = null;

function apply() {
  const title = pageTitle || fallbackTitle;
  document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
}

export function setFallbackTitle(title: string | null) {
  fallbackTitle = title;
  apply();
}

/** Browser tab title for the current page, e.g. "translate_fragments · Performance". */
export function usePageTitle(title?: string | null) {
  useEffect(() => {
    if (!title) return undefined;
    pageTitle = title;
    apply();
    return () => {
      if (pageTitle === title) {
        pageTitle = null;
        apply();
      }
    };
  }, [title]);
}
